const { IP_PUBLIC, APP_DOMAIN } = Config;

import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router";
import { toast } from "react-toastify";
import { ButtonBase, InputBase } from "../../../common/components/form";
import * as API from "../../lib/api.js";
import { BLACK_LIST } from "../../lib/black-list.js";
import Wait from "../Wait";
import DNSCheck from "./DNSCheck.jsx";

const reDomain = /^([a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])\.)+[a-z0-9]{1,61}$/;

export default function WebsiteDomain() {
    const { t } = useTranslation();
    const { id } = useParams();

    const history = useHistory();

    const [wait, setWait] = React.useState(false);
    const [loading, setLoading] = React.useState(true);
    const [prevDomain, setPrevDomain] = React.useState("");
    const [project, setProject] = React.useState([]);
    const [blackList, setBackList] = React.useState(null);

    const [prevProjectJson, setPrevProjectJson] = React.useState("");

    React.useEffect(() => {
        id && Load(id);
    }, [id]);

    function Load(id_project) {
        setLoading(true);
        return API.Send("/project/get", { id_project })
            .then(project => {
                if (!project?.ok) {
                    return;
                }

                setPrevDomain(project.domain);
                setProject(project || []);

                setPrevProjectJson(JSON.stringify(project));
            })
            .finally(() => setLoading(false));
    }

    function onDomainChange({ target: { value } }) {
        const subdomain = value?.match(/(.*?)\./) && value?.match(/(.*?)\./)[1];

        if (BLACK_LIST.includes(subdomain)) {
            setBackList(true);
            toast.error(t("RESERVED_WORDS_NOT_ALLOWED"));
        } else {
            setBackList(false);
        }

        setProject({ ...project, domain: value.trim() });
    }

    function onCancelClick() {
        history.goBack();
    }

    function onSaveClick() {
        setWait(true);
        API.CompileUpdateProject({ ...project, id_project: project.id })
            .then(() => history.goBack())
            .catch(e => {
                for (const error of e) {
                    toast.error(t(error.error));
                }
            })
            .finally(() => setWait(false));
    }

    const domain = project?.domain;
    const isDomainOk = reDomain.test(domain);
    const isOwnDomain = new RegExp(`${APP_DOMAIN.replace(/\./g, "\\.")}$`).test(domain);

    const allowSave = prevProjectJson !== JSON.stringify(project) && isDomainOk;

    return (
        <>
            <div className="website-settings domain">
                {loading && <h2 className="panel-heading-text">{t("Loading")}...</h2>}

                {!loading && project && (
                    <>
                        <h2 className="panel-heading-text">{prevDomain}</h2>

                        <div className="website-settings-fields">
                            <div>
                                <InputBase
                                    onChange={onDomainChange}
                                    value={domain || ""}
                                    placeholder={t("YourDomainNameGoesHere")}
                                />
                            </div>
                        </div>

                        <div className="website-settings-instruction">
                            <h4>{t("WebsiteSettingsHeading")}</h4>
                            <p>{t("WebsiteSettingsWStep1")}</p>
                            <p>{t("WebsiteSettingsWStep3")}</p>
                            <p>{t("WebsiteSettingsWStep4")}</p>

                            <div>
                                {t("WebsiteSettingsWStep5")}
                                <pre>{IP_PUBLIC}</pre>
                            </div>

                            <div>
                                <b>{t("Notice")}!</b> {t("WebsiteSettingNoticeDNS")}
                            </div>

                            {!isOwnDomain && isDomainOk && <DNSCheck domain={domain} every={false} />}
                        </div>

                        <div className="website-settings-actions">
                            <ButtonBase solid onClick={() => onCancelClick()}>
                                {t("Cancel")}
                            </ButtonBase>

                            <ButtonBase invert onClick={() => onSaveClick()} disabled={!allowSave || blackList}>
                                {t("Save")}
                            </ButtonBase>
                        </div>
                    </>
                )}
            </div>

            <Wait show={wait} />
        </>
    );
}
